import React, { useState } from 'react'
import { AgGridReact } from "ag-grid-react";
import {
  Check,
  Clock,
  Download,
  EyeIcon,
  House,
  PencilLine,
  RefreshCw,
  TriangleExclamation,
  PiggyBank,
  CircleInfo,
  FilePdf,
  HeartPulse,
  GraduationCap,
  Folder,
  HandHoldingHeart,
  Users,
  FileContract,
  Plus,
  ChartLine,
  BuildingColumns,
  Calculator,
  DotFill
} from '../../../../components/icons/Icons'
import TableSkeleton from "../../../../components/table/TableSkeleton.js";
import { Row, Col } from 'react-bootstrap';
import ProgressBar from 'react-bootstrap/ProgressBar';


const ProofsDocuments = () => {
  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  const paginationPageSize = 10;

  const [proofDocList, setProofDocList] = useState([
    { id: 1, period: "Apr–Jun 2024", uploadDate: "15 Jun 2024", declaredAmount: "₹75,000", orcRead: "₹74,800", status: "Verified" },
    { id: 2, period: "Jul–Sep 2024", uploadDate: "15 Sep 2024", declaredAmount: "₹75,000", orcRead: "₹74,800", status: "Verified" },
    { id: 3, period: "Oct–Dec 2024", uploadDate: "15 Dec 2024", declaredAmount: "₹75,000", orcRead: "₹74,800", status: "In Review" },
    { id: 4, period: "Jan–Mar 2025", uploadDate: "Pending", declaredAmount: "-", orcRead: "-", status: "Missing" },
  ])

  const columns = [
    // {
    //   headerName: "SNo",
    //   valueGetter: (params) => params.node.rowIndex + 1,
    //   width: 60,
    //   pinned: "left",
    // },
    {
      headerName: "Period",
      field: "period",
      width: 120,
      pinned: "left",
    },
    {
      headerName: "Upload Date",
      field: "uploadDate",
      width: "350px",
    },
    {
      headerName: "Declared Amount",
      field: "declaredAmount",
      width: "200px",
    },

    {
      headerName: "OCR Read",
      field: "orcRead",
      width: "200px",
      autoHeight: true,
      wrapText: true,
      resizable: true,
      cellClass: "custom-wrap-cell",
    },

    {
      headerName: "Status",
      field: "Status",
      cellRenderer: (rowData) => {
        return <span
          style={{ height: "30px", width: "100px", position: "relative", top: "4px" }}
          className={
            rowData.data.status == "Verified" ? "badge-green"
              : rowData.data.status == "In Review"
                ? "badge-orange" : rowData.data.status == "Missing" ? "badge-red" : ""}>
          {
            rowData.data.status == "Verified" ? <Check />
              : rowData.data.status == "In Review"
                ? <Clock /> : rowData.data.status == "Missing" ? <TriangleExclamation /> : ""
          }
          {rowData.data.status}
        </span>
      }
    },

    {
      headerName: "Action",
      pinned: "right",
      width: "150px",
      cellRenderer: (rowData) => {
        return (
          <div
            style={{ position: "relative", top: "9px" }}
            className="d-flex align-items-center justify-content-start gap-3"
          >
            <EyeIcon class_name={"text-purple font-20"} /> <Download />
          </div>
        );
      },
    },
  ];

  const statements = [
    { id: 1, statement: "PPF Statement", fileName: "PPF_Statement_2024.pdf", declared: "₹1,50,000", orcRead: "₹74,800", status: "Verified", isEdit: false, now: "20" },
    { id: 1, statement: "Life Insurance", fileName: "LIC_Premium.pdf", declared: "₹1,50,000", orcRead: "₹74,800", status: "Exceeds Cap", isEdit: true, now: "40" },
    { id: 1, statement: "ELSS Mutual Fund", fileName: "ELSS_Receipt.pdf", declared: "₹1,50,000", orcRead: "₹74,800", status: "Verified", isEdit: false, now: "80" },
  ]

  const otherDeductions = [
    { id: 1, icon: <BuildingColumns />, title: "Section 80TTA", subTitle: "Savings Account Interest", declaredName: "Interest Earned", declared: "₹1,50,000", eligible: "₹74,800", maxLimit: "10,000", status: "Verified", isEdit: false, now: "20", isDownload: true, },
    { id: 1, icon: <House />, title: "Section 24B", subTitle: "Home Loan Interest", declaredName: "Interest Paid", declared: "₹1,50,000", eligible: "₹74,800", maxLimit: "2,00,000", status: "Verified", isEdit: true, now: "40", isDownload: true, },
    { id: 1, icon: <ChartLine />, title: "NPS 80CCD(1B)", subTitle: "National Pension Scheme", declaredName: "Contribution", declared: "₹1,50,000", eligible: "Pending", maxLimit: "50,000", status: "Pending", isEdit: false, now: "80", isDownload: false, },
  ]

  const donations = [
    {
      organization: "Helping Hands Trust",
      registration: "80G/2021/AABTH1234K",
      receipt: "donation_Q2.pdf",
      declared: "₹10,000",
      ocrRead: "₹10,000",
      eligiblePercent: "50%",
      allowed: "₹5,000",
      status: "Verified"
    },
    {
      organization: "NGO Relief Fund",
      registration: "80G/2020/AABCN5678M",
      receipt: "donation_Q4.pdf",
      declared: "₹15,000",
      ocrRead: "₹14,800",
      eligiblePercent: "100%",
      allowed: "₹14,800",
      status: "In Review"
    }
  ];

  const donationColumns = [
    // {
    //   headerName: "SNo",
    //   valueGetter: (params) => params.node.rowIndex + 1,
    //   width: 60,
    //   pinned: "left",
    // },
    {
      headerName: "Organization",
      cellRenderer: (rowData) => {
        return <div>
          <h3 className='color-white font-weight-200 font-16'>{rowData.data.organization}</h3>
          <h4 className='color-gray font-weight-200 font-12'>{rowData.data.registration}</h4>
        </div>
      },
      autoHeight: true,
      width: 320,
      pinned: "left",
    },
    {
      headerName: "Receipt",
      field: "receipt",
      width: "350px",
    },
    {
      headerName: "Declared Amount",
      field: "declared",
      width: "200px",
    },

    {
      headerName: "OCR Read",
      field: "orcRead",
      width: "200px",
      autoHeight: true,
      wrapText: true,
      resizable: true,
      cellClass: "custom-wrap-cell",
    },

    {
      headerName: "Eligible Percent",
      field: "eligiblePercent",
      width: "200px",
      autoHeight: true,
      wrapText: true,
      resizable: true,
      cellClass: "custom-wrap-cell",
    },

    {
      headerName: "Allowed",
      field: "eligiblePercent",
      width: "200px",
      autoHeight: true,
      wrapText: true,
      resizable: true,
      cellClass: "custom-wrap-cell",
    },


    {
      headerName: "Status",
      field: "Status",
      cellRenderer: (rowData) => {
        return <span
          style={{ height: "30px", width: "100px", position: "relative", top: "4px" }}
          className={
            rowData.data.status == "Verified" ? "badge-green"
              : rowData.data.status == "In Review"
                ? "badge-orange" : rowData.data.status == "Missing" ? "badge-red" : ""}>
          {
            rowData.data.status == "Verified" ? <Check />
              : rowData.data.status == "In Review"
                ? <Clock /> : rowData.data.status == "Missing" ? <TriangleExclamation /> : ""
          }
          {rowData.data.status}
        </span>
      }
    },

    {
      headerName: "Action",
      pinned: "right",
      width: "150px",
      cellRenderer: (rowData) => {
        return (
          <div
            style={{ position: "relative", top: "9px" }}
            className="d-flex align-items-center justify-content-start gap-3"
          >
            <EyeIcon class_name={"text-purple font-20"} /> <Download />
          </div>
        );
      },
    },
  ];

  return (
    <div>
      <div className='d-flex align-items-center justify-content-between gap-2'>
        <h3 className='color-white d-flex align-items-center gap-2'>
          <House class_name={"text-purple font-20"} /> HRA (House Rent Allowance)
        </h3>
        <div className='d-flex align-items-center gap-3'>
          <span className='color-gray'>Last updated: 15 Dec 2024</span>
          <span className='text-purple d-flex align-items-center gap-2'> <RefreshCw /> Refresh OCR</span>
        </div>
      </div>

      <div
        className="ag-theme-quartz custom-grid mt-4 border-g border-radius-8px p-4"
        style={{ height: "calc(100vh - 310px)", width: "100%" }}
      >
        {/* {state.commonGetLoading ? (
          <TableSkeleton />
        ) : ( */}
        <AgGridReact
          rowData={Array.isArray(proofDocList) ? proofDocList : []}
          columnDefs={columns}
          omLayout="autoHeight"
          pagination={true}
          paginationPageSize={paginationPageSize}
          onGridReady={onGridReady}
        />
        {/* )} */}
      </div>

      <h3 className='mt-4 mb-4 color-white d-flex align-items-center gap-2'> <PiggyBank class_name={"text-purple font-20"} /> Section 80C – Investments & Savings</h3>

      <div className='setting-border height-auto p-3 mb-4'>
        <Row>
          <Col sm="3">
            <div className='d-flex align-items-center flex-column gap-1'>
              <h3 className='color-white'>₹1,80,000</h3>
              <span className='color-gray'>Total Declared</span>
            </div>
          </Col>

          <Col sm="3">
            <div className='d-flex align-items-center flex-column gap-1'>
              <h3 className='text-green'>₹1,50,000</h3>
              <span className='color-gray'>Allowed Amount</span>
            </div>
          </Col>

          <Col sm="3">
            <div className='d-flex align-items-center flex-column gap-1'>
              <h3 className='text-purple'>₹1,50,000</h3>
              <span className='color-gray'>Section Cap</span>
            </div>
          </Col>

          <Col sm="3">
            <div className='d-flex align-items-center flex-column gap-1'>
              <h3 className='color-white'><CircleInfo class_name={"text-green"} /> </h3>
              <span className='color-gray'>Status: Capped</span>
            </div>
          </Col>
        </Row>
      </div>

      <Row>
        {
          statements.map(item => {
            return <Col sm="4" key={item.id}>
              <div className='emp-tds-card'>
                <div className='d-flex align-items-center justify-content-between mb-3'>
                  <div className='d-flex align-items-center gap-2'>
                    <FilePdf class_name={"text-red font-20"} />
                    <div>
                      <h3 className='font-weight-200 color-white'>{item.statement}</h3>
                      <span className='font-weight-200 color-gray'>{item.fileName}</span>
                    </div>
                  </div>
                  <div className={item.status == "Verified" ? "badge-green" : item.status == "Exceeds Cap" ? "badge-orange" : ""}>
                    {item.status}
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-between mb-2'>
                  <span className='font-weight-200 color-gray'>Declared</span>
                  <span className='font-weight-200 color-gray'>{item.declared}</span>

                </div>
                <div className='d-flex align-items-center justify-content-between'>
                  <span className='font-weight-200 color-gray'>ORC Read</span>
                  <span className={
                    item.status == "Verified" ? 'font-weight-200 text-green'
                      : item.status == "Exceeds Cap" ? 'font-weight-200 orange-text-one' : "font-weight-200"} >{item.orcRead}</span>
                </div>
                <ProgressBar now={item.now} visuallyHidden className={item.status == "Verified" ? "custom-bar-green mt-3 mb-3" : item.status == "Exceeds Cap" ? "custom-bar-orange mt-3 mb-3" : ""} />

                <div className='d-flex align-items-center justify-content-between mt-3'>
                  <span className='font-weight-200 text-purple d-flex align-items-center gap-2'>
                    <EyeIcon class_name={"text-purple font-20"} /> View
                  </span>
                  <span className='font-weight-200 color-white'>
                    {
                      item.isEdit ? <span className='d-flex align-items-center gap-2'><PencilLine /> Download</span> : <span className='d-flex align-items-center gap-2'><Download /> Download</span>
                    }
                  </span>
                </div>
              </div>
            </Col>
          })
        }

      </Row>

      <h3 className='mt-4 mb-4 color-white d-flex align-items-center gap-2'> <HeartPulse class_name={"text-purple font-20"} /> Section 80D – Medical Insurance</h3>

      <div className='setting-border height-auto p-3 mb-4'>
        <Row>
          <Col sm="3">
            <div className='d-flex align-items-center flex-column gap-1'>
              <h3 className='color-white'>₹55,000</h3>
              <span className='color-gray'>Total Declared</span>
            </div>
          </Col>

          <Col sm="3">
            <div className='d-flex align-items-center flex-column gap-1'>
              <h3 className='text-green'>₹50,000</h3>
              <span className='color-gray'>Allowed Amount</span>
            </div>
          </Col>

          <Col sm="3">
            <div className='d-flex align-items-center flex-column gap-1'>
              <h3 className='text-purple'>2 / 3</h3>
              <span className='color-gray'>Documents</span>
            </div>
          </Col>

          <Col sm="3">
            <div className='d-flex align-items-center flex-column gap-1'>
              <h3 className='color-white'><CircleInfo class_name={"text-orange"} /> </h3>
              <span className='color-gray'>Partially Verified</span>
            </div>
          </Col>
        </Row>
      </div>

      <Row>
        {
          statements.map(item => {
            return <Col sm="4" key={item.id}>
              <div className='emp-tds-card'>
                <div className='d-flex align-items-center justify-content-between mb-3'>
                  <div className='d-flex align-items-center gap-2'>
                    <Users class_name={"text-info font-20"} />
                    <div>
                      <h3 className='font-weight-200 color-white'>{item.statement}</h3>
                      <span className='font-weight-200 color-gray'>{item.fileName}</span>
                    </div>
                  </div>
                  <div className={item.status == "Verified" ? "badge-green" : item.status == "Exceeds Cap" ? "badge-orange" : ""}>
                    {item.status}
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-between mb-2'>
                  <span className='font-weight-200 color-gray'>Declared</span>
                  <span className='font-weight-200 color-gray'>{item.declared}</span>

                </div>
                <div className='d-flex align-items-center justify-content-between'>
                  <span className='font-weight-200 color-gray'>ORC Read</span>
                  <span className={
                    item.status == "Verified" ? 'font-weight-200 text-green'
                      : item.status == "Exceeds Cap" ? 'font-weight-200 orange-text-one' : "font-weight-200"} >{item.orcRead}</span>
                </div>

                <div className='d-flex align-items-center justify-content-between mt-3'>
                  <span className='font-weight-200 text-purple d-flex align-items-center gap-2'>
                    <EyeIcon class_name={"text-purple font-20"} /> View
                  </span>
                  <span className='font-weight-200 color-white'>
                    {
                      item.isEdit ? <span className='d-flex align-items-center gap-2'><PencilLine /> Download</span> : <span className='d-flex align-items-center gap-2'><Download /> Download</span>
                    }
                  </span>
                </div>
              </div>
            </Col>
          })
        }

      </Row>

      <h3 className='mt-4 mb-4 color-white d-flex align-items-center gap-2'> <GraduationCap class_name={"text-purple font-20"} /> Section 80E – Education Loan Interest</h3>

      <div className='setting-border height-auto p-3 mb-4'>
        <Row>
          <Col sm="3">
            <div className='d-flex align-items-center flex-column gap-1'>
              <h3 className='color-white'>₹45,000</h3>
              <span className='color-gray'>Interest Paid</span>
            </div>
          </Col>

          <Col sm="3">
            <div className='d-flex align-items-center flex-column gap-1'>
              <h3 className='text-green'>₹45,000</h3>
              <span className='color-gray'>Eligible Deduction</span>
            </div>
          </Col>

          <Col sm="3">
            <div className='d-flex align-items-center flex-column gap-1'>
              <h3 className='text-purple'>No Limit</h3>
              <span className='color-gray'>Section Cap</span>
            </div>
          </Col>

          <Col sm="3">
            <div className='d-flex align-items-center flex-column gap-1'>
              <h3 className='color-white'><CircleInfo class_name={"text-orange"} /> </h3>
              <span className='color-gray'>Status: Verified</span>
            </div>
          </Col>
        </Row>
      </div>

      <Row>
        {
          statements.map(item => {
            return <Col sm="6" className='mb-4' key={item.id}>
              <div className='emp-tds-card'>
                <div className='d-flex align-items-center justify-content-between mb-3'>
                  <div className='d-flex align-items-center gap-2'>
                    <FileContract class_name={"text-red font-20"} />
                    <div>
                      <h3 className='font-weight-200 color-white'>{item.statement}</h3>
                      <span className='font-weight-200 color-gray'>{item.fileName}</span>
                    </div>
                  </div>
                  <div className={item.status == "Verified" ? "badge-green" : item.status == "Exceeds Cap" ? "badge-orange" : ""}>
                    {item.status}
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-between mb-2'>
                  <span className='font-weight-200 color-gray'>Declared</span>
                  <span className='font-weight-200 color-gray'>{item.declared}</span>

                </div>
                <div className='d-flex align-items-center justify-content-between'>
                  <span className='font-weight-200 color-gray'>ORC Read</span>
                  <span className={
                    item.status == "Verified" ? 'font-weight-200 text-green'
                      : item.status == "Exceeds Cap" ? 'font-weight-200 orange-text-one' : "font-weight-200"} >{item.orcRead}</span>
                </div>

                <div className='d-flex align-items-center justify-content-between mt-3'>
                  <span className='font-weight-200 text-purple d-flex align-items-center gap-2'>
                    <EyeIcon class_name={"text-purple font-20"} /> View
                  </span>
                  <span className='font-weight-200 color-white'>
                    {
                      item.isEdit ? <span className='d-flex align-items-center gap-2'><PencilLine /> Download</span> : <span className='d-flex align-items-center gap-2'><Download /> Download</span>
                    }
                  </span>
                </div>
              </div>
            </Col>
          })
        }

      </Row>

      <h3 className='mt-4 mb-4 color-white d-flex align-items-center gap-2'>
        <HandHoldingHeart class_name={"text-purple font-20"} /> Section 80G – Donations & Contributions
      </h3>

      <div className='setting-border height-auto p-3 mb-4'>
        <Row>
          <Col sm="3">
            <div className='d-flex align-items-center flex-column gap-1'>
              <h3 className='color-white'>₹25,000</h3>
              <span className='color-gray'>Total Donated</span>
            </div>
          </Col>

          <Col sm="3">
            <div className='d-flex align-items-center flex-column gap-1'>
              <h3 className='text-green'>₹19,800</h3>
              <span className='color-gray'>Eligible Deduction</span>
            </div>
          </Col>

          <Col sm="3">
            <div className='d-flex align-items-center flex-column gap-1'>
              <h3 className='text-purple'>2</h3>
              <span className='color-gray'>Organizations</span>
            </div>
          </Col>

          <Col sm="3">
            <div className='d-flex align-items-center flex-column gap-1'>
              <h3 className='color-white'><CircleInfo class_name={"text-green"} /> </h3>
              <span className='color-gray'>Status: Verified</span>
            </div>
          </Col>
        </Row>
      </div>

      <div
        className="ag-theme-quartz custom-grid mt-4 border-g border-radius-8px p-4"
        style={{ height: "calc(100vh - 310px)", width: "100%" }}
      >
        {/* {state.commonGetLoading ? (
          <TableSkeleton />
        ) : ( */}
        <AgGridReact
          rowData={Array.isArray(donations) ? donations : []}
          columnDefs={donationColumns}
          omLayout="autoHeight"
          pagination={true}
          paginationPageSize={paginationPageSize}
          onGridReady={onGridReady}
        />
        {/* )} */}
      </div>

      <h3 className='mt-4 mb-4 color-white d-flex align-items-center gap-2'>
        <Folder class_name={"text-purple font-20"} /> Other Deductions & Exemptions
      </h3>

      <div className='setting-border height-auto p-3 mb-4'>
        <Row>
          <Col sm="3">
            <div className='d-flex align-items-center flex-column gap-1'>
              <h3 className='color-white'>₹75,000</h3>
              <span className='color-gray'>Total Claimed</span>
            </div>
          </Col>

          <Col sm="3">
            <div className='d-flex align-items-center flex-column gap-1'>
              <h3 className='text-green'>₹50,000</h3>
              <span className='color-gray'>Allowed Amount</span>
            </div>
          </Col>

          <Col sm="3">
            <div className='d-flex align-items-center flex-column gap-1'>
              <h3 className='text-purple'>2 / 3</h3>
              <span className='color-gray'>Section Cap</span>
            </div>
          </Col>

          <Col sm="3">
            <div className='d-flex align-items-center flex-column gap-1'>
              <h3 className='color-white'><CircleInfo class_name={"text-orange"} /> </h3>
              <span className='color-gray'>Status: Capped</span>
            </div>
          </Col>
        </Row>
      </div>

      <Row className='mb-4'>

        {
          otherDeductions.map((item) => {
            return <Col sm="4">
              <div className='emp-tds-card green-box-shadow'>
                <div className='d-flex align-items-center justify-content-between mb-3'>
                  <div className='d-flex align-items-center gap-2'>
                    <div className={`font-20 ${item.status == "Verified" ? "text-green" : item.status == "Pending" ? "text-orange" : ""}`}>
                      {item.icon}
                    </div>
                    {/* <FileContract class_name={"text-red font-20"} /> */}
                    <div>
                      <h3 className='font-weight-200 color-white'>{item.title}</h3>
                      <span className='font-weight-200 color-gray'>{item.subTitle}</span>
                    </div>
                  </div>
                  <div className={item.status == "Verified" ? "badge-green" : item.status == "Pending" ? "badge-orange" : ""}>
                    {item.status}
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-between mb-2'>
                  <span className='font-weight-200 color-gray'>{item.declaredName}</span>
                  <span className='font-weight-200 color-gray'>{item.declared}</span>

                </div>
                <div className='d-flex align-items-center justify-content-between'>
                  <span className='font-weight-200 color-gray'>Eligible</span>
                  <span className={
                    item.status == "Verified" ? 'font-weight-200 text-green'
                      : item.status == "Pending" ? 'font-weight-200 orange-text-one' : "font-weight-200"} >{item.eligible}</span>
                </div>

                {
                  item.isDownload ? <div className={`d-flex align-items-center justify-content-between mt-3 ${item.isDownload ? "mb-4" : ""} `}>
                    <span className='font-weight-200 text-purple d-flex align-items-center gap-2'>
                      <EyeIcon class_name={"text-purple font-20"} /> View
                    </span>
                    <span className='font-weight-200 color-white'>
                      <span className='d-flex align-items-center gap-2'><Download /> Download</span>
                    </span>
                  </div> : <div className='d-flex align-items-center justify-content-center mt-3'>
                    <button className='universal-btn border-radius-8px d-flex align-items-center mt-3'><Plus /> Upload Statement </button>
                  </div>
                }

              </div>
            </Col>
          })
        }



      </Row>

      <h3 className='font-weight:200 color-white d-flex align-items-center gap-2 mb-4'> <Calculator class_name={"text-purple"} /> Tax Impact Summary </h3>

      <Row>
        <Col sm="6" className='mb-3'>
          <div className='emp-tds-card'>
            <h3 className='font-weight:200 color-white d-flex align-items-center gap-2'> Tax Savings Breakdown </h3>

            <div className='d-flex align-items-center justify-content-between gap-2 mb-3 mt-3'>
              <span className='color-gray font-16'>HRA Exemption</span>
              <span className='text-green font-16'>₹81,000</span>
            </div>

            <div className='d-flex align-items-center justify-content-between gap-2 mb-3'>
              <span className='color-gray font-16'>80C Deductions</span>
              <span className='text-green font-16'>₹45,000</span>
            </div>

            <div className='d-flex align-items-center justify-content-between gap-2 mb-3'>
              <span className='color-gray font-16'>80D Deductions</span>
              <span className='text-green font-16'>₹15,000</span>
            </div>

            <div className='d-flex align-items-center justify-content-between gap-2 mb-3'>
              <span className='color-gray font-16'>Other Deductions</span>
              <span className='text-green font-16'>₹25,000</span>
            </div>

            <hr className='color-gray' />

            <div className='d-flex align-items-center justify-content-between gap-2 mb-3'>
              <span className='color-white font-16'>Total Tax Saved</span>
              <span className='text-purple font-16'>₹1,66,000</span>
            </div>

          </div>
        </Col>

        <Col sm="6" className='mb-3'>
          <div className='emp-tds-card'>
            <h3 className='font-weight:200 color-white d-flex align-items-center gap-2'> Document Status Overview</h3>

            <div className='d-flex align-items-center justify-content-between gap-2 mb-3 mt-3'>
              <span className='color-gray font-16 d-flex align-items-center gap-2'> <DotFill class_name={"text-green font-20"} /> Verified Documents</span>
              <span className='text-green font-16'>18</span>
            </div>

            <div className='d-flex align-items-center justify-content-between gap-2 mb-3'>
              <span className='color-gray font-16 d-flex align-items-center gap-2'> <DotFill class_name={"text-orange font-20"} /> Pending Review</span>
              <span className='text-orange font-16'>3</span>
            </div>

            <div className='d-flex align-items-center justify-content-between gap-2 mb-3'>
              <span className='color-gray font-16 d-flex align-items-center gap-2'> <DotFill class_name={"text-red font-20"} /> Missing Documents</span>
              <span className='text-red font-16'>1</span>
            </div>

            <div className='d-flex align-items-center justify-content-between gap-2 mb-3'>
              <span className='color-gray font-16 d-flex align-items-center gap-2'> <DotFill class_name={"text-gray font-20"} /> Total Documents</span>
              <span className='text-gray font-16'>22</span>
            </div>

            {/* <ProgressBar now={"70"} visuallyHidden className="custom-bar-orange mt-3 mb-3" /> */}
            <ProgressBar style={{ height: "8px" }}>
              <ProgressBar
                now={33.33}
                className="custom-bar-green"
              />
              <ProgressBar
                now={"33.33"}
                className="custom-bar-yellow"
              />
              <ProgressBar
                now={"33.33"}
                className="custom-bar-red"
              />

              <ProgressBar
                now={"33.33"}
                className="custom-bar-gray"
              />
            </ProgressBar>

            <div className='d-flex align-items-center justify-content-center gap-2 mt-3 mb-3'>
              <span className='text-purple font-16'>82% Complete</span>
            </div>

          </div>
        </Col>
      </Row>

      <div className='setting-border height-auto px-4'>
        <div className='d-flex align-items-center justify-content-between gap-2 mt-3 mb-3'>
          <div className='d-flex align-items-center gap-2 mt-3 mb-3'>
            <span className='color-gray'>Last saved: 2 minutes ago</span> <span className='text-green'><DotFill class_name={"text-green"} /> Auto-save enabled</span>
          </div>
          <div className='d-flex align-items-center gap-2 mt-3 mb-3'>
            <button className='universal-sec-btn border-radius-8px'><Download /> Download All Proofs (ZIP)</button>
            <button className='universal-btn border-radius-8px'><Plus /> Upload More Proofs</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProofsDocuments